import { render, staticRenderFns } from "./CreateCustomerCrmOpportunityPopUp.vue?vue&type=template&id=635590bc&scoped=true&"
import script from "./CreateCustomerCrmOpportunityPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerCrmOpportunityPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerCrmOpportunityPopUp.vue?vue&type=style&index=0&id=635590bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635590bc",
  null
  
)

export default component.exports